import React from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="p-footer p-component p-shadow-2">
      <div className="footer-content">
        <img
          src="/img/majesteye-icon-no-text.png"
          alt="Logo"
          className="footer-logo"
        />
        <p className="footer-text">© 2025 MajestEYE. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
